import { Mail } from "lucide-react";
import { formatDate } from "../../lib/utils";

export const EmailHistory = ({ emails = [], compact = false, testId = "email-history" }) => {
  if (!emails.length) return null;
  const list = [...emails].reverse();
  if (compact) {
    const last = list[0];
    return (
      <p className="text-[11px] text-sky-700 flex items-center gap-1" title={list.map((e) => `${e.to} · ${formatDate(e.at)}${e.by_name ? ` · ${e.by_name}` : ""}`).join("\n")} data-testid={testId}>
        <Mail className="w-3 h-3" /> Enviado {emails.length > 1 ? `${emails.length}× · último ` : ""}para {last.to} em {formatDate(last.at)}
      </p>
    );
  }
  return (
    <div className="rounded-lg border p-3 text-sm" data-testid={testId}>
      <p className="text-xs font-semibold uppercase text-muted-foreground flex items-center gap-1 mb-2"><Mail className="w-3.5 h-3.5" /> Envios por email ({emails.length})</p>
      <ul className="space-y-1">
        {list.map((e, i) => (
          <li key={e.id || i} className="flex flex-wrap justify-between gap-x-3 text-xs" data-testid={`${testId}-item`}>
            <span className="font-medium">{e.to}</span>
            <span className="text-muted-foreground">{formatDate(e.at)}{e.by_name ? ` · ${e.by_name}` : ""}{e.kind === "pos" ? " · POS" : ""}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
